import React from "react";
import { slice } from "lodash";
import styled from "styled-components";
import { FontSize, Spacing, content, form } from "@glossy";
import { Locale } from "@linkfluence/models/locale";
import AutoComplete from "@ui-kit/form/autocomplete";
import Levels from "@radarly/components/filterbar/panels/classification/levels";
import { tr } from "@radarly/i18n";
import {
  Choice,
  ClassificationFilter,
  ClassificationFilters,
} from "@radarly/models/filters";

interface IProps {
  choices: Choice[];
  levelChoices: ClassificationFilters;
  onSelect: (
    filter: ClassificationFilter,
    status: string,
    level?: number
  ) => void;
  onChangeLevel: (level: number, filterId: string) => void;
  locale: Locale;
  currentLevel: number;
  currentFilter: string;
  onReset: () => void;
}

const Hr = styled.div`
  margin-bottom: 24px;
  flex-basis: 1px;
  background-color: ${(props) => content(props, "tertiary")};
`;

const Reset = styled.div`
  cursor: pointer;
  font-size: ${FontSize.Small};
  text-decoration: underline;
  color: ${form};
  margin-bottom: ${Spacing.Medium};
`;

const formatTooltip = (choice: string, locale: Locale): string => {
  const levels = choice.split("/");
  const base = "FACETS::CONTENT_CLASSIFICATION_";
  return levels.reduce((acc, _, i) => {
    const level = i + 1;
    if (level < levels.length) {
      return (acc +=
        tr(locale, `${base}${[...levels].splice(0, level).join("_")}`) + " > ");
    }
    return (acc += tr(locale, `${base}${choice.replace(/[/]/g, "_")}`));
  }, "");
};

const selectPath = (onChangeLevel, choice) => {
  const levels = choice.id.split("/");
  const level = levels.length - 1;
  const filterId = slice(levels, 0, level).join("/");
  onChangeLevel(level, filterId);
};

const FilterbarPanelsClassification = ({
  choices,
  levelChoices,
  onChangeLevel,
  onSelect,
  currentFilter,
  currentLevel,
  locale,
  onReset,
}: IProps) => {
  return (
    <>
      <AutoComplete
        choices={choices}
        onSelect={(value, status) =>
          onSelect(value as ClassificationFilter, status)
        }
        placeholder={tr(locale, "FILTER_PANEL::SEARCH_PLACEHOLDER::CATEGORIES")}
        locale={locale}
        noOptionMessage={tr(locale, "FILTER_PANEL::NO_CATEGORY")}
        allowExclusion
        tooltip={(choice) => formatTooltip(choice, locale)}
        onClickSelectedOption={(choice) => selectPath(onChangeLevel, choice)}
      />
      <Reset onClick={onReset}>{tr(locale, "FILTERS_PANEL::RESET_ALL")}</Reset>
      <Hr />
      <Levels
        classificationFilters={levelChoices}
        currentLevel={currentLevel}
        onChangeLevel={onChangeLevel}
        currentFilter={currentFilter}
        onChangeStatus={onSelect}
        locale={locale}
      />
    </>
  );
};

export default FilterbarPanelsClassification;
